import React, { Fragment, useEffect, useReducer } from 'react';
import { HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isAndroid, noop } from '@philips-internal/oswald-ui-utils';
import { Button } from '../button/button.js';
import { Loader } from '../loader/loader.js';
import { PDFViewerProperties } from './pdf-viewer-types.js';
import './pdf-viewer.css';
// These policies are considered best pratices to have a good experiences
// on the web, when using iframes, and should be enforced when possible.
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Feature_Policy/Using_Feature_Policy#enforcing_best_practices_for_good_user_experiences
const fixedAllowPolicies = [
    `layout-animations 'none'`,
    `oversized-images 'none'`,
    `sync-script 'none'`,
    `sync-xhr 'none'`,
    `unoptimized-images 'none'`,
    `unsized-media 'none'`,
];
function downloadButtonStateReducer(data, partialData) {
    return {
        ...data,
        ...partialData,
    };
}
const initialDownloadState = {
    downloadButtonEnabled: true,
    localSrc: '',
    popBlocker: false,
};
function PDFViewerDownloadButton(props) {
    const [{ downloadButtonEnabled, localSrc, popBlocker }, setState] = useReducer(downloadButtonStateReducer, initialDownloadState);
    const { buttonTheme = PDFViewerProperties.buttonTheme.defaultValue, src, downloadingPdfExpression = PDFViewerProperties.downloadingPdfExpression.defaultValue, downloadPdfExpression = PDFViewerProperties.downloadPdfExpression.defaultValue, openPdfExpression = PDFViewerProperties.openPdfExpression.defaultValue, showDownloadButton, } = props;
    useEffect(() => {
        if (!localSrc) {
            return;
        }
        return () => {
            URL.revokeObjectURL(localSrc);
        };
    }, [localSrc]);
    if (!showDownloadButton && !isAndroid()) {
        return null;
    }
    const openPdf = (src) => {
        window.open(src);
    };
    const handleSuccess = (response) => {
        if (!response || !response.body) {
            return;
        }
        const newURL = URL.createObjectURL(response.body);
        if (!popBlocker) {
            window.open(newURL);
        }
        setState({ downloadButtonEnabled: true, localSrc: newURL, popBlocker: false });
    };
    const handleError = () => {
        setState({ downloadButtonEnabled: true, localSrc: '', popBlocker: false });
    };
    const doDownload = (src) => {
        setState({ downloadButtonEnabled: false });
        HttpService.get(src)
            .then(handleSuccess)
            .catch(handleError);
        setTimeout(() => {
            if (!downloadButtonEnabled) {
                setState({ popBlocker: true });
            }
        }, 500);
    };
    if (localSrc) {
        return (React.createElement(Button, { className: "c-pdf-viewer__button", fitParent: true, onClick: () => openPdf(localSrc), theme: buttonTheme, value: MessageService.translate(openPdfExpression) }));
    }
    if (downloadButtonEnabled) {
        return (React.createElement(Button, { className: "c-pdf-viewer__button", fitParent: true, onClick: () => doDownload(src), theme: buttonTheme, value: MessageService.translate(downloadPdfExpression) }));
    }
    return (React.createElement(Fragment, null,
        React.createElement(Button, { className: "c-pdf-viewer__button", enabled: false, fitParent: true, onClick: noop, theme: buttonTheme, value: MessageService.translate(downloadingPdfExpression) }),
        React.createElement(Loader, { className: "c-pdf-viewer__download-loader", size: 64 })));
}
function PDFViewer(props) {
    const { loading, src, visible = PDFViewerProperties.visible.defaultValue, } = props;
    const styles = {
        height: 'auto',
        width: '100%',
    };
    if (!visible) {
        return null;
    }
    if (isAndroid()) {
        return (React.createElement("div", { className: "c-pdf-viewer__android" },
            React.createElement(PDFViewerDownloadButton, { ...props })));
    }
    return (React.createElement("div", { className: "c-pdf-viewer" },
        loading
            ? React.createElement(Loader, { className: "c-pdf-viewer__loader", size: 64 })
            : React.createElement("iframe", { allow: fixedAllowPolicies.join('; '), src: src, style: styles }),
        React.createElement(PDFViewerDownloadButton, { ...props })));
}
export { PDFViewer, };
export default PDFViewer;
//# sourceMappingURL=pdf-viewer.js.map